import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Tooltip from 'flarum/common/components/Tooltip';
import humanTime from 'flarum/common/helpers/humanTime';
import icon from '../../common/helpers/icon';
import ItemList from 'flarum/common/utils/ItemList';
import classList from 'flarum/common/utils/classList';
import app from 'flarum/forum/app';
export default class FeaturedBlogItem extends Component {
  topItems() {
    var _article$tags, _article$isSticky, _article$blogMeta, _article$blogMeta$isP, _article$blogMeta2, _article$blogMeta2$is;
    const article = this.attrs.article;
    const items = new ItemList();
    items.add('tags', m("span", {
      class: "BlogFeatured-list-item-tags"
    }, (_article$tags = article.tags()) == null ? void 0 : _article$tags.map(tag => m("span", {
      class: "dataItem"
    }, tag.name()))), 100);

    // Sticky is an optional dependency, so we can't
    // assume method existence.
    if ((_article$isSticky = article.isSticky) != null && _article$isSticky.call(article)) {
      items.add('sticky', m("span", {
        class: "BlogFeatured-list-item-isSticky dataItem"
      }, icon('fas fa-thumbtack')), 80);
    }
    if ((_article$blogMeta = article.blogMeta()) != null && (_article$blogMeta$isP = _article$blogMeta.isPendingReview) != null && _article$blogMeta$isP.call(_article$blogMeta) || article.isHidden()) {
      items.add('hidden', m("span", {
        class: "BlogFeatured-list-item-isHidden dataItem"
      }, icon('fas fa-eye-slash')), 60);
    }
    if ((_article$blogMeta2 = article.blogMeta()) != null && (_article$blogMeta2$is = _article$blogMeta2.isPendingReview) != null && _article$blogMeta2$is.call(_article$blogMeta2)) {
      items.add('pendingReview', m(Tooltip, {
        text: app.translator.trans('v17development-flarum-blog.forum.review_article.pending_review'),
        position: "bottom"
      }, m("span", {
        class: "BlogFeatured-list-item-pendingReview dataItem"
      }, icon('far fa-clock'), " ", app.translator.trans('v17development-flarum-blog.forum.review_article.pending_review_title'))), 40);
    }
    return items;
  }
  dataItems() {
    var _article$user;
    const article = this.attrs.article;
    const items = new ItemList();
    items.add('createdAt', m("span", {
      class: "BlogFeatured-list-item-details-createdAt"
    }, icon('far fa-clock'), " ", humanTime(article.createdAt())), 100);
    items.add('author', m("span", {
      class: "BlogFeatured-list-item-details-author"
    }, icon('far fa-user'), " ", ((_article$user = article.user()) == null ? void 0 : _article$user.displayName()) || app.translator.trans('core.lib.username.deleted_text')), 80);
    items.add('replies', m("span", {
      class: "BlogFeatured-list-item-details-replies"
    }, icon('far fa-comment'), " ", article.commentCount() - 1), 60);
    return items;
  }
  view(vnode) {
    var _article$blogMeta3, _article$blogMeta3$fe, _article$lastReadPost;
    const _this$attrs = this.attrs,
      article = _this$attrs.article,
      defaultImage = _this$attrs.defaultImage;
    const blogImage = (_article$blogMeta3 = article.blogMeta()) != null && (_article$blogMeta3$fe = _article$blogMeta3.featuredImage) != null && _article$blogMeta3$fe.call(_article$blogMeta3) ? "url(".concat(article.blogMeta().featuredImage(), ")") : defaultImage;
    const lastRead = (_article$lastReadPost = article.lastReadPostNumber) == null ? void 0 : _article$lastReadPost.call(article);
    let near;
    if (lastRead && lastRead > 0) {
      near = lastRead;
    }
    return m(Link, {
      href: app.route.discussion(article, near),
      className: classList('BlogFeatured-list-item', article.tags().map(tag => "BlogFeatured-list-item-category-".concat(tag.id())), 'FlarumBlog-default-image'),
      style: {
        backgroundImage: blogImage
      }
    }, m("div", {
      class: "BlogFeatured-list-item-top"
    }, this.topItems().toArray()), m("div", {
      className: "BlogFeatured-list-item-details"
    }, m("h4", null, article.title()), m("div", {
      className: "data"
    }, this.dataItems().toArray())));
  }
}
flarum.reg.add('v17development-blog', 'forum/components/FeaturedBlogItem', FeaturedBlogItem);